import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
    collection,
    doc,
    onSnapshot,
    updateDoc,
    deleteDoc,
    getDocs,
    getDoc
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext";
import { MdAdd, MdDelete, MdDeleteOutline, MdRemove } from "react-icons/md";
import "./chart.css";
import { RiShoppingCartLine } from "react-icons/ri";

export const seo = {
    title: "Shopping Cart | Add Items & Continue Your Order on aooz",
    description:
        "Easily add items to your shopping cart and continue your order with aooz. Manage products, review selections, and checkout seamlessly for a smooth shopping experience.",
    keywords:
        "shopping cart, add to cart, continue order, online shopping, order management, checkout, cart page, aooz cart, buy online",
    url: "https://aooz.in/cart",
    image: "https://aooz.in/assets/logo.png",
};

// ✅ Guest ID generator
function getGuestId() {
    let guestId = localStorage.getItem("guestId");
    if (!guestId) {
        guestId = "guest_" + Math.random().toString(36).substring(2, 12);
        localStorage.setItem("guestId", guestId);
    }
    return guestId;
}

export default function Chart_details() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    const [cartItems, setCartItems] = useState([]);
    const [guestId, setGuestId] = useState(getGuestId());
    const [loading, setLoading] = useState(true);

    // ✅ Detect login and update guestId
    useEffect(() => {
         const sessionToken = Cookies.get("sessiontoken");
         const guid = Cookies.get("guid");
         if (sessionToken && guid) {
             setGuestId(guid);
         }
         else{
           //  navigate('/login');
         }
     }, []);

    // ✅ Listen to Firestore cart items and get product details
    useEffect(() => {
        if (!guestId) return;

        const itemsRef = collection(db, "cart_items", guestId, "items");

        const unsubscribe = onSnapshot(
            itemsRef,
            async (snapshot) => {
                const cartList = snapshot.docs.map((doc) => ({
                    uid: doc.id,
                    ...doc.data(),
                }));

                if (cartList.length === 0) {
                    setCartItems([]);
                    setLoading(false);
                    return;
                }

                try {
                    const allProducts = [];

                    for (const item of cartList) {
                        if (!item.productuid) continue;

                        const productRef = doc(db, "products", item.productuid);
                        const productSnap = await getDoc(productRef);
                        if (!productSnap.exists()) continue;

                        const productData = productSnap.data();

                        // Fetch fields subcollection
                        const fieldsSnap = await getDocs(collection(productRef, "fields"));
                        let child = {};
                        fieldsSnap.forEach((fieldDoc) => {
                            const { fieldName, fieldValue } = fieldDoc.data();
                            child[fieldName] = fieldValue;
                        });

                        allProducts.push({ uid: productSnap.id, ...productData, child });
                    }

                    // Merge cart items with product info
                    const mergedData = cartList.map((cartItem) => {
                        const product = allProducts.find((p) => p.uid === cartItem.productuid);
                        return { ...cartItem, product };
                    });

                    setCartItems(mergedData);
                } catch (err) {
                    console.error("Error fetching product info:", err);
                    Toastshow("Failed to load product details.");
                } finally {
                    setLoading(false);
                }
            },
            (error) => {
                console.error("Error fetching cart items:", error);
                Toastshow("Error loading cart items.");
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [guestId]);

  

    // ✅ Calculate total
    const totalAmount = cartItems.reduce(
        (sum, item) => sum + ((item.product?.child?.price || 0) * (item.qty || 1)),
        0
    );

    return (
        <div> 
 {cartItems.length > 0 && (
  <div className="chart_details">
    <div className="container_size rounded p-1 items-back shadow">
      <div className="post-container">
        <div className="post_div">
          <div className="text-h1 flex items-center">

            {/* 🛒 Cart count and total quantity */}
            <div className="button-ui2 b-1 p-11 rounded m-1 flex items-center gap-1">
              <RiShoppingCartLine className="icon" />
              <span className="text-h1 ">
               <a className="bold">{cartItems.length}</a> <span className="text-off text-h2"> Items /{" "}</span>
               <a className="bold">{cartItems.reduce((sum, i) => sum + (i.qty || 1), 0)}</a><span className="text-off text-h2"> Qty</span>
              </span>
            </div>

            {/* 💰 Total price */}
            <div className="b-1 p-11 rounded m-1 items-back-fill">
              <span className="text-off text-h2">Total: </span>
              <span className="text-h1 bold">
                ₹{totalAmount.toLocaleString()}/-
              </span>
            </div>
          </div>
        </div>

        <div className="post_updates">
          <div
            className="button-ui green-back fill center rounded p-2 text-h1 cursor"
            onClick={() => navigate("/checkout")}
          >
            Proceed to Order
          </div>
        </div>
      </div>
    </div>
  </div>
)}

              
      
        </div>
    );
}
